export const handleLogin = () => {
	const clientId = 511936531788597;
	const redirectUri = encodeURIComponent(`${window.location.origin}/callback`);
	const scope =
		"threads_basic,threads_content_publish,threads_manage_insights,threads_read_replies,threads_content_publish,threads_manage_replies";
	const authUrl = `https://www.threads.net/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=code`;
	window.location.href = authUrl;
	console.log(redirectUri);
};
